import queryString from "query-string";
import * as actionTypes from "../constants/actionTypes";
import * as params from "../constants/urlQueryParams";
import { createParam, paramBase } from "../lib/urlQueryParam";
import { OFFER_TYPES } from "../constants/offerTypes";

function addOrReplaceInUrlQuery(clientConfigId, history, value, nestedParams) {
  const currentUrlQuery = history.location.search;
  const currentUrlQueryParams = queryString.parse(currentUrlQuery, {
    arrayFormat: "bracket"
  });
  const tdsPcParam = createParam(clientConfigId, nestedParams);
  let newUrlQueryParams = currentUrlQueryParams;

  if (value == null) {
    delete newUrlQueryParams[tdsPcParam];
  } else {
    newUrlQueryParams[tdsPcParam] = value;
  }

  const newUrlQuery = queryString.stringify(newUrlQueryParams, {
    arrayFormat: "bracket"
  });

  history.replace({ search: newUrlQuery });
}

function addOrReplaceFilterInUrlQuery(
  offerType,
  filter,
  clientConfigId,
  history
) {
  const filterTypeKey = getFilterTypeKey(offerType);

  for (const key of Object.keys(filter)) {
    const value = filter[key];
    const nestedParams = [filterTypeKey, key];
    addOrReplaceInUrlQuery(clientConfigId, history, value, nestedParams);
  }
}

function addOrReplaceSortInUrlQuery(offerType, sort, clientConfigId, history) {
  const sortTypeKey = getSortTypeKey(offerType);
  const nestedParams = [sortTypeKey];

  addOrReplaceInUrlQuery(clientConfigId, history, sort, nestedParams);
}

function getFilterTypeKey(offerType) {
  if (offerType === OFFER_TYPES.phoneOffer) {
    return params.FILTER_PHONE_OFFER;
  } else if (offerType === OFFER_TYPES.proposition) {
    return params.FILTER_PROPOSITION;
  } else if (offerType === OFFER_TYPES.simOnly) {
    return params.FILTER_SIM_ONLY;
  }
}

function getSortTypeKey(offerType) {
  if (offerType === OFFER_TYPES.phoneOffer) {
    return params.SORT_PHONE_OFFER;
  } else if (offerType === OFFER_TYPES.proposition) {
    return params.SORT_PROPOSITION;
  } else if (offerType === OFFER_TYPES.simOnly) {
    return params.SORT_SIM_ONLY;
  }
}

function resetFilterUrlQuery(offerType, newFilter, clientConfigId, history) {
  const currentUrlQuery = history.location.search;
  const currentUrlQueryParams = queryString.parse(currentUrlQuery);

  let newUrlQueryParams = currentUrlQueryParams;

  for (const key of Object.keys(currentUrlQueryParams)) {
    if (key.indexOf(paramBase(clientConfigId)) >= 0) {
      const filterTypeKey = getFilterTypeKey(offerType);

      if (key.indexOf(filterTypeKey) >= 0) {
        delete newUrlQueryParams[key];
      }
    }
  }

  const newUrlQuery = queryString.stringify(newUrlQueryParams);
  history.replace({ search: newUrlQuery });

  addOrReplaceFilterInUrlQuery(offerType, newFilter, clientConfigId, history);
}

function resetFiltersUrlQuery(newFilter, clientConfigId, history) {
  for (const key of Object.keys(newFilter)) {
    resetFilterUrlQuery(key, newFilter[key], clientConfigId, history);
  }
}

function resetSortsUrlQuery(newSort, clientConfigId, history) {
  for (const key of Object.keys(newSort)) {
    addOrReplaceSortInUrlQuery(key, null, clientConfigId, history);
  }
}

const actionToUrlQuery = history => ({
  getState,
  dispatch
}) => next => action => {
  const clientConfig = getState().clientConfig;
  if (clientConfig) {
    const configId = clientConfig.id;
    switch (action.type) {
      case actionTypes.RESET_FILTER:
        resetFilterUrlQuery(action.offerType, {}, configId, history);
        break;
      case actionTypes.RESET_FILTERS:
        resetFiltersUrlQuery(
          {
            [OFFER_TYPES.phoneOffer]: {},
            [OFFER_TYPES.proposition]: {},
            [OFFER_TYPES.simOnly]: {}
          },
          configId,
          history
        );
        break;
      case actionTypes.RESET_SORT:
        addOrReplaceSortInUrlQuery(action.offerType, null, configId, history);
        break;
      case actionTypes.RESET_SORTS:
        resetSortsUrlQuery(action.sort, configId, history);
        break;
      case actionTypes.SWITCH_OFFER_TYPE:
        addOrReplaceInUrlQuery(configId, history, action.offerType, [
          params.OFFER_TYPE
        ]);
        break;
      case actionTypes.SWITCH_PORTAL:
        addOrReplaceInUrlQuery(configId, history, action.id, [params.PORTAL]);
        break;
      case actionTypes.UPDATE_FILTER:
        addOrReplaceFilterInUrlQuery(
          action.offerType,
          action.filter,
          configId,
          history
        );
        break;
      case actionTypes.UPDATE_SORT:
        addOrReplaceSortInUrlQuery(
          action.offerType,
          action.sort,
          configId,
          history
        );
        break;
      default:
      // add nothing to the url query
    }
  }
  return next(action);
};

export default actionToUrlQuery;
